import styled from 'styled-components'

export const StyledRatings = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem 1.5rem;
  justify-content: start;
  align-content: start;
`
